import { render, staticRenderFns } from "./index_2024.vue?vue&type=template&id=27d390a0&scoped=true&lang=pug&"
import script from "./index_2024.vue?vue&type=script&lang=js&"
export * from "./index_2024.vue?vue&type=script&lang=js&"
import style0 from "./index_2024.vue?vue&type=style&index=0&id=27d390a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d390a0",
  null
  
)

export default component.exports